<template>
	<div v-if="data">
		<h4>Aging Stock {{text}}</h4>
		<div class="row mt-3">
			<div class="col-6 text-center">
				<img src="@/assets/img/Highlights/Total.png" style="width:100%;"/>
				<h5>{{this.data.series}}</h5>
			</div>
			<div class="col-6">
				<table class="table table-borderless">
					<tbody>
						<tr v-if="this.data.no_mesin">
							<td>Nomor Mesin</td>
							<td><h5>{{this.data.no_mesin}}</h5></td>
						</tr>
						<tr>
							<td>Aging Stock</td>
							<td><h5>{{this.data.aging_day}} Day{{this.data.aging_day > 1 ? 's' : ''}}</h5></td>
						</tr>
						<tr>
							<td>Region</td>
							<td><h5>{{this.data.region}} - {{this.data.region_name}}</h5></td>
						</tr>
						<tr>
							<td>Warehouse</td>
							<td><h5>{{this.data.loc_code}} - {{this.data.loc_name}}</h5></td>
						</tr>
						<tr>
							<td>Tgl Masuk</td>
							<td><h5>{{this.data.tgl_masuk}}</h5></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['dataMD' , 'dataD' , 'dataEnd' , 'selected' , 'text'],
	data () {
		return {
			data : null
		}
	},
	watch : {
		selected : function () {
			this.data = null
			this.data = this.selected == 'endtoend' ? this.dataEnd : this.selected == 'maindealer' ? this.dataMD : this.dataD
		}
	},
	mounted () {
		this.data = null
		this.data = this.selected == 'endtoend' ? this.dataEnd : this.selected == 'maindealer' ? this.dataMD : this.dataD
	}
}
</script>